import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ml-4 pb-10 space-y-2" }
const _hoisted_2 = { class: "space-y-4 bg-white rounded-xl p-4" }
const _hoisted_3 = { class: "space-y-4 flex flex-row flex-wrap" }
const _hoisted_4 = { class: "my-1 gap-1 flex flex-wrap" }
const _hoisted_5 = {
  key: 1,
  class: "text-12px xxl:text-14px text-black-lp-200"
}
const _hoisted_6 = { class: "my-1 gap-1 flex flex-wrap" }
const _hoisted_7 = {
  key: 1,
  class: "text-12px xxl:text-14px text-black-lp-200"
}
const _hoisted_8 = { class: "my-1" }
const _hoisted_9 = {
  key: 1,
  class: "text-12px xxl:text-14px text-black-lp-200 capitalize"
}
const _hoisted_10 = { class: "my-1" }
const _hoisted_11 = {
  key: 1,
  class: "text-12px xxl:text-14px text-black-lp-200 capitalize"
}
const _hoisted_12 = { class: "my-1" }
const _hoisted_13 = {
  key: 1,
  class: "text-12px xxl:text-14px text-black-lp-200 capitalize"
}
const _hoisted_14 = { class: "my-1" }
const _hoisted_15 = {
  key: 1,
  class: "text-12px xxl:text-14px text-black-lp-200 capitalize"
}
const _hoisted_16 = { class: "my-1 gap-1 flex flex-wrap" }
const _hoisted_17 = {
  key: 1,
  class: "text-12px xxl:text-14px text-black-lp-200 capitalize"
}
const _hoisted_18 = { class: "my-1 gap-1 flex flex-wrap" }
const _hoisted_19 = {
  key: 1,
  class: "text-12px xxl:text-14px text-black-lp-200 capitalize"
}
const _hoisted_20 = { class: "my-1 gap-1 flex flex-wrap" }
const _hoisted_21 = {
  key: 1,
  class: "text-12px xxl:text-14px text-black-lp-200 capitalize"
}
const _hoisted_22 = { class: "my-1 gap-1 flex flex-wrap" }
const _hoisted_23 = {
  key: 1,
  class: "text-12px xxl:text-14px text-black-lp-200 capitalize"
}
const _hoisted_24 = { class: "space-y-4 bg-white rounded-xl p-4" }
const _hoisted_25 = { class: "space-y-4 flex flex-row flex-wrap" }
const _hoisted_26 = { class: "my-1 gap-1 flex flex-wrap" }
const _hoisted_27 = {
  key: 1,
  class: "text-12px xxl:text-14px text-black-lp-200 capitalize"
}
const _hoisted_28 = {
  key: 0,
  class: "gap-1 flex"
}
const _hoisted_29 = {
  key: 0,
  class: "my-1 rounded-md px-2 bg-gray-lp-200 text-12px xxl:text-14px text-black-lp-200"
}
const _hoisted_30 = {
  key: 1,
  class: "my-1 rounded-md px-2 bg-gray-lp-200 text-12px xxl:text-14px text-black-lp-200"
}
const _hoisted_31 = {
  key: 1,
  class: "text-12px xxl:text-14px text-black-lp-200 capitalize"
}
const _hoisted_32 = { class: "my-1 gap-1 flex flex-wrap" }
const _hoisted_33 = {
  key: 1,
  class: "text-12px xxl:text-14px text-black-lp-200 capitalize"
}
const _hoisted_34 = { class: "space-y-4 bg-white rounded-xl py-4" }
const _hoisted_35 = { class: "space-y-4 flex flex-row flex-wrap border-t border-gray-lp-1400 pt-4 px-4" }
const _hoisted_36 = { class: "rounded-xl p-4 bg-white space-y-4" }
const _hoisted_37 = { class: "flex capitalize mt-1" }
const _hoisted_38 = { class: "flex flex-col my-1" }
const _hoisted_39 = { class: "text-left text-black-lp-200 font-semibold" }
const _hoisted_40 = { class: "text-gray-lp-600" }
const _hoisted_41 = { class: "flex flex-col my-1" }
const _hoisted_42 = { class: "text-left text-black-lp-200 font-semibold" }
const _hoisted_43 = { class: "text-gray-lp-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_MessageVariables = _resolveComponent("MessageVariables")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    scrollSidebar: "",
    customClass: "detail-message-config",
    onBack: _ctx.goBack,
    title: _ctx.id.toString(),
    loading: _ctx.isLoading,
    error: !!_ctx.errorCause,
    errorType: _ctx.errorCause,
    onTryAgain: _ctx.fetchDetailData,
    verticalSeparator: false,
    headerNewLayout: ""
  }, {
    data: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Title, {
            label: "Kriteria konfigurasi pesan",
            bold: "bold",
            fontColor: "text-black-lp-200"
          }),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, {
              class: "w-full",
              label: "ID Konfig",
              fontStyleLabel: "font-bold text-black-lp-200",
              customStyleValue: "my-1 font-normal break-words text-black-lp-200",
              value: _ctx.detailData.msgConfId
            }, null, 8, ["value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: "Judul Pesan",
              fontStyleLabel: "font-bold text-black-lp-200",
              customStyleValue: "my-1 font-normal break-words text-black-lp-200",
              value: _ctx.detailData.msgConfName
            }, null, 8, ["value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2 capitalize",
              label: "Tipe pesan",
              fontStyleLabel: "font-bold text-black-lp-200",
              customStyleValue: "my-1 font-normal break-words text-black-lp-200",
              value: _ctx.formatJsonToString(_ctx.detailData.msgConfType)
            }, null, 8, ["value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2 capitalize",
              label: "Tipe layanan",
              fontStyleLabel: "font-bold text-black-lp-200",
              customStyleValue: "my-1 font-normal break-words text-black-lp-200",
              value: _ctx.formatJsonToString(_ctx.detailData.msgConfPacketType)
            }, null, 8, ["value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: "Status berita",
              fontStyleLabel: "font-bold text-black-lp-200",
              customStyleValue: "my-1 font-normal break-words text-black-lp-200",
              value: _ctx.sttLastStatus
            }, null, 8, ["value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-full",
              label: "Alasan dari status berita",
              fontStyleLabel: "font-bold text-black-lp-200"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_4, [
                  (_ctx.detailData.msgConfReason.length)
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.detailData.msgConfReason, (item, index) => {
                        return (_openBlock(), _createBlock("span", {
                          key: index,
                          class: "my-1 rounded-md px-2 bg-gray-lp-200 text-12px xxl:text-14px text-black-lp-200"
                        }, _toDisplayString(item), 1))
                      }), 128))
                    : (_openBlock(), _createBlock("p", _hoisted_5, " - "))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "w-full",
              label: "Jenis pengiriman",
              fontStyleLabel: "font-bold text-black-lp-200"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_6, [
                  (_ctx.detailData.msgConfProduct)
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.stringToArray(
                      _ctx.detailData.msgConfProduct
                    ), (item, index) => {
                        return (_openBlock(), _createBlock("span", {
                          key: index,
                          class: "my-1 rounded-md px-2 bg-gray-lp-200 text-12px xxl:text-14px text-black-lp-200"
                        }, _toDisplayString(item), 1))
                      }), 128))
                    : (_openBlock(), _createBlock("p", _hoisted_7, " - "))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "w-full",
              label: "STT dibuat untuk?",
              fontStyleLabel: "font-bold text-black-lp-200"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_8, [
                  (_ctx.detailData.msgConfBookedFor)
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.stringToArray(
                      _ctx.detailData.msgConfBookedFor
                    ), (item, index) => {
                        return (_openBlock(), _createBlock("p", {
                          key: index,
                          class: "my-1 text-12px xxl:text-14px text-black-lp-200 capitalize"
                        }, _toDisplayString(_ctx.convertToUppercase(item)), 1))
                      }), 128))
                    : (_openBlock(), _createBlock("p", _hoisted_9, " - "))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: "Nama POS",
              fontStyleLabel: "font-bold text-black-lp-200",
              customStyleValue: "my-1 font-normal break-words text-black-lp-200",
              value: 
                _ctx.convertToUppercase(
                  _ctx.detailData.msgConfPosName?.replaceAll(';', ',')
                )
              
            }, null, 8, ["value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: "Pengecualian POS",
              fontStyleLabel: "font-bold text-black-lp-200"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_10, [
                  (_ctx.detailData.msgConfPosNameExclude)
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.stringToArray(
                      _ctx.detailData.msgConfPosNameExclude?.replaceAll(';', ',')
                    ), (item, index) => {
                        return (_openBlock(), _createBlock("p", {
                          key: index,
                          class: "my-1 text-12px xxl:text-14px text-black-lp-200 capitalize"
                        }, _toDisplayString(_ctx.convertToUppercase(item)), 1))
                      }), 128))
                    : (_openBlock(), _createBlock("p", _hoisted_11, " - "))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: "Nama Client Cabang",
              fontStyleLabel: "font-bold text-black-lp-200",
              customStyleValue: "my-1 font-normal break-words text-black-lp-200",
              value: _ctx.detailData.msgConfClientName?.replaceAll(';', ',')
            }, null, 8, ["value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: "Pengecualian Client Cabang",
              fontStyleLabel: "font-bold text-black-lp-200"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_12, [
                  (_ctx.detailData.msgConfClientNameExclude)
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.stringToArray(
                      _ctx.detailData.msgConfClientNameExclude?.replaceAll(';', ',')
                    ), (item, index) => {
                        return (_openBlock(), _createBlock("p", {
                          key: index,
                          class: "my-1 text-12px xxl:text-14px text-black-lp-200 capitalize"
                        }, _toDisplayString(item), 1))
                      }), 128))
                    : (_openBlock(), _createBlock("p", _hoisted_13, " - "))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: "Nama Client Parent",
              fontStyleLabel: "font-bold text-black-lp-200",
              customStyleValue: "my-1 font-normal break-words text-black-lp-200",
              value: _ctx.detailData.msgConfClientParentName?.replaceAll(';', ',')
            }, null, 8, ["value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: "Pengecualian Client Parent",
              fontStyleLabel: "font-bold text-black-lp-200"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_14, [
                  (_ctx.detailData.msgConfClientParentNameExclude)
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.stringToArray(
                      _ctx.detailData.msgConfClientParentNameExclude?.replaceAll(';', ',')
                    ), (item, index) => {
                        return (_openBlock(), _createBlock("p", {
                          key: index,
                          class: "my-1 text-12px xxl:text-14px text-black-lp-200 capitalize"
                        }, _toDisplayString(item), 1))
                      }), 128))
                    : (_openBlock(), _createBlock("p", _hoisted_15, " - "))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: "Kota Asal",
              fontStyleLabel: "font-bold text-black-lp-200"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_16, [
                  (_ctx.detailData.msgConfOriginCity)
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.stringToArray(
                      _ctx.detailData.msgConfOriginCity
                    ), (item, index) => {
                        return (_openBlock(), _createBlock("span", {
                          key: index,
                          class: "rounded-md px-2 bg-gray-lp-200 text-12px xxl:text-14px text-black-lp-200"
                        }, _toDisplayString(item), 1))
                      }), 128))
                    : (_openBlock(), _createBlock("p", _hoisted_17, " - "))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: "Pengecualian kota asal",
              fontStyleLabel: "font-bold text-black-lp-200"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_18, [
                  (_ctx.detailData.msgConfOriginCityExclude)
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.stringToArray(
                      _ctx.detailData.msgConfOriginCityExclude
                    ), (item, index) => {
                        return (_openBlock(), _createBlock("span", {
                          key: index,
                          class: "rounded-md px-2 bg-gray-lp-200 text-12px xxl:text-14px text-black-lp-200"
                        }, _toDisplayString(item), 1))
                      }), 128))
                    : (_openBlock(), _createBlock("p", _hoisted_19, " - "))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: "Kota tujuan",
              fontStyleLabel: "font-bold text-black-lp-200"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_20, [
                  (_ctx.detailData.msgConfDestinationCity)
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.stringToArray(
                      _ctx.detailData.msgConfDestinationCity
                    ), (item, index) => {
                        return (_openBlock(), _createBlock("span", {
                          key: index,
                          class: "rounded-md px-2 bg-gray-lp-200 text-12px xxl:text-14px text-black-lp-200"
                        }, _toDisplayString(item), 1))
                      }), 128))
                    : (_openBlock(), _createBlock("p", _hoisted_21, " - "))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: "Pengecualian kota tujuan",
              fontStyleLabel: "font-bold text-black-lp-200"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_22, [
                  (_ctx.detailData.msgConfDestinationCityExclude)
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.stringToArray(
                      _ctx.detailData.msgConfDestinationCityExclude
                    ), (item, index) => {
                        return (_openBlock(), _createBlock("span", {
                          key: index,
                          class: "rounded-md px-2 bg-gray-lp-200 text-12px xxl:text-14px text-black-lp-200"
                        }, _toDisplayString(item), 1))
                      }), 128))
                    : (_openBlock(), _createBlock("p", _hoisted_23, " - "))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: "Tanggal mulai konfigurasi",
              value: 
                _ctx.formatDateWithoutTime(_ctx.detailData.msgConfSchedulePeriodeStart)
              ,
              fontStyleLabel: "font-bold text-black-lp-200",
              customStyleValue: "my-1 font-normal break-words text-black-lp-200"
            }, null, 8, ["value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: "Tanggal selesai konfigurasi",
              value: 
                _ctx.formatDateWithoutTime(_ctx.detailData.msgConfSchedulePeriodeEnd)
              ,
              fontStyleLabel: "font-bold text-black-lp-200",
              customStyleValue: "my-1 font-normal break-words text-black-lp-200"
            }, null, 8, ["value"])
          ])
        ]),
        _createVNode("div", _hoisted_24, [
          _createVNode(_component_Title, {
            label: "Aturan konfigurasi pesan",
            bold: "bold",
            fontColor: "text-black-lp-200"
          }),
          _createVNode("div", _hoisted_25, [
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: "Target pesan",
              fontStyleLabel: "font-bold text-black-lp-200"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_26, [
                  (_ctx.detailData.msgConfTarget)
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.stringToArray(
                      _ctx.detailData.msgConfTarget
                    ), (item, index) => {
                        return (_openBlock(), _createBlock("span", {
                          key: index,
                          class: "rounded-md px-2 bg-gray-lp-200 text-12px xxl:text-14px text-black-lp-200 capitalize"
                        }, _toDisplayString(_ctx.formatJsonToString(item)), 1))
                      }), 128))
                    : (_openBlock(), _createBlock("p", _hoisted_27, " - "))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: "Maksimal Pesan",
              value: _ctx.detailData.msgConfMaxMessage,
              fontStyleLabel: "font-bold text-black-lp-200",
              customStyleValue: "my-1 font-normal break-words text-black-lp-200"
            }, null, 8, ["value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-full",
              label: "Rute",
              fontStyleLabel: "font-bold text-black-lp-200"
            }, {
              default: _withCtx(() => [
                (
                  _ctx.detailData.msgConfIntracity || _ctx.detailData.msgConfIntercity
                )
                  ? (_openBlock(), _createBlock("div", _hoisted_28, [
                      (_ctx.detailData.msgConfIntracity)
                        ? (_openBlock(), _createBlock("span", _hoisted_29, " INTRACITY "))
                        : _createCommentVNode("", true),
                      (_ctx.detailData.msgConfIntercity)
                        ? (_openBlock(), _createBlock("span", _hoisted_30, " INTERCITY "))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock("p", _hoisted_31, " - "))
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "w-full",
              label: "SLA",
              fontStyleLabel: "font-bold text-black-lp-200"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_32, [
                  (_ctx.detailData.msgConfSla)
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.stringToArray(_ctx.detailData.msgConfSla), (item, index) => {
                        return (_openBlock(), _createBlock("span", {
                          key: index,
                          class: "rounded-md px-2 bg-gray-lp-200 text-12px xxl:text-14px text-black-lp-200 capitalize"
                        }, _toDisplayString(_ctx.formatJsonToString(item)), 1))
                      }), 128))
                    : (_openBlock(), _createBlock("p", _hoisted_33, " - "))
                ])
              ]),
              _: 1
            }),
            (_ctx.detailData.isDex)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  class: "w-full",
                  label: "DEX attempt ke?",
                  value: _ctx.detailData.msgConfAttemptDex,
                  fontStyleLabel: "font-bold text-black-lp-200",
                  customStyleValue: "my-1 font-normal break-words text-black-lp-200"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            (_ctx.detailData.isOverSla)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 1,
                  class: "w-1/2 capitalize",
                  label: "Hari over SLA Lebih dari",
                  value: _ctx.detailData.msgConfCountSla,
                  fontStyleLabel: "font-bold text-black-lp-200",
                  customStyleValue: "my-1 font-normal break-words text-black-lp-200"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            (_ctx.detailData.isOverSla)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 2,
                  class: "w-1/2 capitalize",
                  label: "Waktu kirim pesan over SLA",
                  value: `${String(_ctx.detailData.msgConfCronHours).padStart(2, '0')}:00 WIB`,
                  fontStyleLabel: "font-bold text-black-lp-200",
                  customStyleValue: "my-1 font-normal break-words text-black-lp-200"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_34, [
          _createVNode(_component_Title, {
            class: "px-4",
            label: "Detail Pesan",
            bold: "bold",
            fontColor: "text-black-lp-200"
          }),
          _createVNode("div", _hoisted_35, [
            (_ctx.detailData.msgConfType !== 'wa_premium')
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  class: "w-full",
                  label: "Isi Pesan",
                  asterisk: "",
                  value: _ctx.detailData.msgConfMessageText,
                  customStyleValue: "my-1 font-normal break-words text-gray-lp-300 border border-gray-lp-400 rounded-md p-2"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            (_ctx.detailData.msgConfType === 'wa_premium')
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 1,
                  class: "w-full",
                  label: "Template Pesan",
                  asterisk: "",
                  value: _ctx.detailData.msgConfTemplateNameWaPremium,
                  customStyleValue: "my-1 font-normal break-words text-gray-lp-300 border border-gray-lp-400 rounded-md p-2"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            (_ctx.detailData.msgConfType === 'wa_premium')
              ? (_openBlock(), _createBlock(_component_MessageVariables, {
                  key: 2,
                  modelValue: _ctx.detailData.msgConfMeta,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.detailData.msgConfMeta = $event)),
                  detail: "",
                  class: "w-full",
                  tableFontSize: "text-xs"
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    "sub-data": _withCtx(() => [
      _createVNode("div", _hoisted_36, [
        _createVNode(_component_DataWrapper, {
          class: "w-full",
          label: "Status",
          fontStyleLabel: "font-normal"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_37, [
              _createVNode("div", {
                class: _ctx.onChipStatus(_ctx.detailData.msgConfStatus)
              }, _toDisplayString(_ctx.detailData.msgConfStatus), 3)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          class: "w-full",
          label: "Tanggal Dibuat",
          fontStyleLabel: "font-normal"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_38, [
              _createVNode("div", _hoisted_39, [
                _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.detailData.msgConfCreatedAt)) + " ", 1),
                _createVNode("div", _hoisted_40, _toDisplayString(_ctx.detailData.msgConfCreatedBy || "-"), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          class: "w-full",
          label: "Tanggal Diperbarui",
          fontStyleLabel: "font-normal"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_41, [
              _createVNode("div", _hoisted_42, [
                _createTextVNode(_toDisplayString(_ctx.formatDate(
                  _ctx.detailData.msgConfUpdatedAt || _ctx.detailData.msgConfCreatedAt
                )) + " ", 1),
                _createVNode("div", _hoisted_43, _toDisplayString(_ctx.detailData.msgConfUpdatedBy ||
                    _ctx.detailData.msgConfCreatedBy ||
                    "-"), 1)
              ])
            ])
          ]),
          _: 1
        }),
        (_ctx.ableToEdit)
          ? (_openBlock(), _createBlock(_component_LpButton, {
              key: 0,
              title: "Ubah",
              onClick: _ctx.goToEdit,
              textColor: "white",
              iconLeft: "ics_o_edit",
              iconGroupHoverColor: ""
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]))
}